export type RowColorMode = 'none' | 'status'

export function getRowClassName(
  mode: RowColorMode,
  orderStatus?: string,
): string {
  if (mode !== 'status' || !orderStatus) return ''
  switch (orderStatus) {
    case 'VOIDED':
    case 'CANCELLED':
      return 'bg-destructive/5'
    case 'REFUNDED':
      return 'bg-orange-50 dark:bg-orange-950/20'
    default:
      return ''
  }
}
